import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';

import BootstrapStarterUIContainer from './BootstrapStarterUIContainer';
import PageLanding from './PageLanding';
import PageLearning from './PageLearning';
import PageSupporting from './PageSupporting';
import TopNav from './TopNav';

const App = () => {
  const [fileName, setFileName] = useState("");
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkSession = async () => {
      try {
        const response = await fetch('/api/auth/session', {
          credentials: 'include'
        });
        const data = await response.json();
        setUser(data.user);
      } catch (err) {
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    checkSession();
  }, []);

  if (loading) return <div style={{ padding: "20px" }}>Loading...</div>;

  return (
    <BrowserRouter>
      <TopNav user={user} />

      <Routes>
        <Route path="/" element={<PageLanding />} />

        <Route
          path="/app"
          element={
            user
              ? <BootstrapStarterUIContainer
                fileName={fileName}
                setFileName={setFileName}
              />
              : <Navigate to="/" replace />
          }
        />

        <Route path="/learning" element={<PageLearning />} />

        <Route
          path="/account"
          element={
            user
              ? <PageSupporting user={user} setUser={setUser} />
              : <Navigate to="/" replace />
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default App;